import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  listProduction(producer_id, crop_id) {
    return RequesterV1.get("open_queries/producer/basic_production_list/"+producer_id+"/"+crop_id);
  },
  getProductionDetails(harvested_batch_id) {
    return RequesterV1.get("open_queries/producer/basic_production_details/"+harvested_batch_id);
  },
  downloadRepXlsx(producer_id, crop_id) {
    return RequesterV1.get(
      "open_queries/producer/basic_production_rep_xlsx/"+producer_id+"/"+crop_id,
      { responseType: "blob" }
    );
  }
};
